// ── synonyms.js — 식재료 별명 → 표준명 사전 ──────────────
// KAMIS·네이버 검색 전에 normalizeFoodName() 호출해 매칭률 향상.
// 사용자 입력 "백오이" → "오이"로 변환 후 매칭/검색.

// 1) 직접 매핑 (예외 케이스 — 자주 보는 별명)
const ALIASES = {
  // 채소 — 오이 계열
  '백오이': '오이',
  '다다기오이': '오이',
  '취청오이': '오이',
  '청오이': '오이',
  '가시오이': '오이',
  // 양파
  '신선양파': '양파',
  '햇양파': '양파',
  '깐양파': '양파',
  '적양파': '양파',
  '자색양파': '양파',
  // 파
  '대파': '파',
  '쪽파': '파',
  '실파': '파',
  '손질대파': '파',
  '깐대파': '파',
  '뿌리대파': '파',
  // 마늘
  '깐마늘': '마늘',
  '다진마늘': '마늘',
  '햇마늘': '마늘',
  // 당근
  '세척당근': '당근',
  '흙당근': '당근',
  '햇당근': '당근',
  // 배추
  '얼갈이배추': '배추',
  '쌈배추': '배추',
  '봄배추': '배추',
  '월동배추': '배추',
  '알배기배추': '배추',
  '봄동': '배추',
  // 고추
  '청양고추': '고추',
  '풋고추': '고추',
  '꽈리고추': '고추',
  '오이고추': '고추',
  '아삭이고추': '고추',
  '홍고추': '고추',
  '건고추': '고추',
  // 무
  '왜무': '무',
  '알타리무': '무',
  '총각무': '무',
  '햇무': '무',
  // 감자
  '햇감자': '감자',
  '수미감자': '감자',
  '대지감자': '감자',
  '자색감자': '감자',
  // 호박
  '애호박': '호박',
  '단호박': '호박',
  '늙은호박': '호박',
  '주키니호박': '호박',
  // 잎채소
  '청상추': '상추',
  '적상추': '상추',
  '꽃상추': '상추',
  '쌈채소': '상추',
  '쌈채': '상추',
  // 과일
  '햇사과': '사과',
  '부사사과': '사과',
  '홍로사과': '사과',
  '아오리사과': '사과',
  '햇배': '배',
  '신고배': '배',
  // 곡류
  '백미': '쌀',
  '햇쌀': '쌀',
  '찹쌀': '쌀',
  '현미': '쌀',
  // 식육
  '국내산돼지고기': '돼지고기',
  '냉장돼지고기': '돼지고기',
  '냉동돼지고기': '돼지고기',
  '한돈': '돼지고기',
  '국내산쇠고기': '쇠고기',
  '냉장쇠고기': '쇠고기',
  '냉동쇠고기': '쇠고기',
  '한우': '쇠고기',
  '국내산닭고기': '닭고기',
  '냉장닭고기': '닭고기',
  '냉동닭고기': '닭고기',
  '한닭': '닭고기',
  // 수산
  '국산고등어': '고등어',
  '냉동고등어': '고등어',
  '노르웨이고등어': '고등어',
  '제주고등어': '고등어',
  '국산갈치': '갈치',
  '제주갈치': '갈치',
  '먹갈치': '갈치',
};

// 2) "알려진 표준명" — 접두 제거 후 이게 남으면 OK
const KNOWN_ROOTS = new Set([
  // 채소·과일
  '오이', '양파', '파', '마늘', '당근', '배추', '고추', '무', '감자', '호박',
  '상추', '시금치', '깻잎', '미나리', '부추', '쑥갓', '냉이', '취나물', '도라지',
  '버섯', '느타리', '팽이', '표고', '양송이',
  '사과', '배', '귤', '감', '포도', '복숭아', '자두', '딸기', '수박', '참외', '메론', '바나나',
  // 곡류·콩류
  '쌀', '보리', '밀가루', '콩', '팥', '녹두', '땅콩',
  // 식육·수산·계란
  '돼지고기', '쇠고기', '닭고기', '오리고기',
  '고등어', '갈치', '꽁치', '명태', '대구', '오징어', '낙지', '문어', '새우', '게', '굴', '조개',
  '계란', '달걀', '메추리알',
  // 가공·조미
  '간장', '된장', '고추장', '쌈장', '소금', '설탕', '식초', '식용유', '참기름', '들기름',
  '우유', '치즈', '버터', '요거트',
  '두부', '콩나물', '숙주',
]);

// 3) 흔한 접두어 (제거 후 KNOWN_ROOTS에 매칭되면 normalize)
const PREFIXES = [
  '국내산', '국산', '수입산', '중국산', '미국산', '호주산', '뉴질랜드산',
  '냉동', '냉장', '생', '말린', '건조', '훈제',
  '햇', '봄', '여름', '가을', '겨울', '월동',
  '세척', '깐', '손질', '다진', '간', '썬',
  '신선', '유기농', '친환경', '무농약',
  '국산', '제주', '강원', '충청',
];

/**
 * 식재료명 정규화 — 별명·수식어 제거해 표준명으로
 * @param {string} name
 * @returns {string}  표준명 (변환 안 되면 원본)
 */
export function normalizeFoodName(name) {
  if (!name) return '';
  const trimmed = String(name).trim().replace(/\s+/g, '');
  if (!trimmed) return '';

  // 직접 매핑 우선
  if (ALIASES[trimmed]) return ALIASES[trimmed];

  // 접두 제거 후 KNOWN_ROOTS 매칭 (안전한 경우만)
  for (const p of PREFIXES) {
    if (trimmed.startsWith(p) && trimmed.length > p.length) {
      const rest = trimmed.slice(p.length);
      if (KNOWN_ROOTS.has(rest)) return rest;
      if (ALIASES[rest]) return ALIASES[rest];
    }
  }

  return trimmed;
}

/**
 * 매칭 시도 시 후보 이름들 — 원본 + 정규화된 이름 + alias
 * (Naver 검색에서 fallback 시도용)
 */
export function matchCandidates(name) {
  const normalized = normalizeFoodName(name);
  if (normalized === name) return [name];
  return [name, normalized];
}

export { ALIASES, KNOWN_ROOTS };
